import isBlank from "@sedan-utils/is-blank";
const GROUP_REG = /^group/;
const SELECT_API_REG = /^\//;
const CUSTOM_FUNCTION_VARS_HTML_REG = /\$\{(currentSourceNodeValue|brainAuthToken)}/g;
const CUSTOM_FUNCTION_VARS_JS_REG = /currentSourceNodeValue|brainAuthToken/g;
class RegExpResultItem {
    constructor(orginalText, isMatch) {
        this.orginalText = orginalText;
        this.isMatch = isMatch;
    }
}
export function isGroupByName(name = "") {
    if (isBlank(name)) {
        return false;
    }
    return GROUP_REG.test(name);
}
export function isSelectApi(name = "") {
    if (isBlank(name)) {
        return false;
    }
    return SELECT_API_REG.test(name);
}
export function transformHtmlVar(html, { currentSourceNodeValue, brainAuthToken }) {
    return html.replaceAll(CUSTOM_FUNCTION_VARS_HTML_REG, substring => {
        if (substring === "${currentSourceNodeValue}")
            return `${currentSourceNodeValue}`;
        if (substring === "${brainAuthToken}")
            return `${brainAuthToken}`;
        return ``;
    });
}
export function transformJsVar(jsStr, { currentSourceNodeValue, brainAuthToken }) {
    return jsStr.replaceAll(CUSTOM_FUNCTION_VARS_JS_REG, substring => {
        if (substring === "currentSourceNodeValue")
            return `${currentSourceNodeValue}`;
        if (substring === "brainAuthToken")
            return `${brainAuthToken}`;
        return ``;
    });
}
export function splitTextFunc(textAreaValue = "", paramText) {
    let text = (textAreaValue || paramText || "").trim();
    if (isBlank(text)) {
        console.log("The segmented text is empty.");
        return [];
    }
    const reg = /\n{2,}/;
    const numReg = /\n+\d*\.*-*:*\s*/;
    const onlyNumReg = /^\n+\d*\.*-*:*\s*$/;
    //两个换行符切分
    const twoBlankLineArr = (text.split(reg) || []).filter((x) => !isBlank(x));
    if (twoBlankLineArr.length > 1)
        return twoBlankLineArr;
    //以数字开头的切分
    text = text.replace(/^\d*\.*-*:*\s*/, "");
    const numSplitArr = (text.split(numReg) || []).filter((x) => !isBlank(x?.trim()) && !onlyNumReg.test(x?.trim()));
    if (numSplitArr.length > 1)
        return numSplitArr;
    return [text];
}
/**
 * 将字符串拆分后返回，并表明哪个字段是已经拆分了的。ke用于UI层面的富文本显示
 * @param text
 */
export function regExpMatch(text, regExp) {
    const dataList = text.split(regExp);
    const newData = [];
    const urls = text.match(regExp);
    let i = 0;
    dataList.forEach((value, index) => {
        newData.push(new RegExpResultItem(value, false));
        if (urls && !isBlank(urls) && index != dataList.length - 1) {
            newData.push(new RegExpResultItem(urls[i], true));
            i = i + 1;
        }
    });
    return newData;
}
